import axios from 'axios'
import qs from 'qs'
import { get as lodashGet } from 'lodash'

import { setAccessToken, getAccessToken, clearAccessToken } from './auth'

axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.defaults.paramsSerializer = params => {
    return qs.stringify(params, { arrayFormat: 'indices' })
}

export const baseURL = import.meta.env.VITE_BASE_URI ? import.meta.env.VITE_BASE_URI : '/api'

const api = axios.create({
    baseURL,
})

api.interceptors.request.use(
    function (config) {
        const token = getAccessToken()
        if (token) config.headers['X-Auth-Token'] = token
        let csrf = document.head.querySelector('meta[name="csrf-token"]')
        if (csrf) {
            config.headers['X-CSRF-TOKEN'] = csrf.content
        }

        try {
            if (window.Echo && window.Echo.socketId()) {
                config.headers['X-Socket-ID'] = window.Echo.socketId()
            }
        } catch (e) {
            // skip it
        }

        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    function ({ data, headers }) {
        let newtoken = headers.authorization || false
        if (newtoken) setAccessToken(newtoken.replace('Bearer ', ''))
        return transformResponseData(data)
    },
    function (error) {
        if (!error.response) {
            return Promise.reject(error.message)
        }
        switch (error.response.status) {
            case 401:
                clearAccessToken()
                return Promise.reject(401)
            case 500:
                if (
                    lodashGet(error, 'response.data.errors.message') ==
                    'Token Signature could not be verified.'
                ) {
                    clearAccessToken()
                    return Promise.reject(401)
                }
        }
        return Promise.reject(error)
    }
)

function transformResponseData(data) {
    if (typeof data === 'object' && data !== null) {
        if (Array.isArray(data)) {
            return data.map(transformResponseData)
        } else {
            const transformedObject = {}
            for (const key in data) {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    const value = data[key]
                    if (typeof value === 'object' && value !== null) {
                        transformedObject[key] = transformResponseData(value)
                    } else if (value === 'true') {
                        transformedObject[key] = true
                    } else if (value === 'false') {
                        transformedObject[key] = false
                    } else {
                        transformedObject[key] = value
                    }
                }
            }
            return transformedObject
        }
    }

    return data
}

export default api
